// Author NYA
// Date 2020-11-10 11:33:21

class SithMesPrdPpStatusUpdateLog {
constructor({
        id = null,
        prdPpOperationId = '',
        prdPpHeaderId = '',
        orderCode = '',
        type = '',
        prdPpStatusCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdPpOperationId = prdPpOperationId;
    this.prdPpHeaderId = prdPpHeaderId;
    this.orderCode = orderCode;
    this.type = type;
    this.prdPpStatusCode = prdPpStatusCode;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpStatusUpdateLog();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.prdPpOperationId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.prdPpHeaderId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.type',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpStatusCode',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.prdPpStatusCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    prdPpOperationIdFilter : "",
    prdPpHeaderIdFilter : "",
    orderCodeFilter : "",
    typeFilter : "",
    prdPpStatusCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdPpOperationIdFilter',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.filter.prdPpOperationId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.filter.prdPpHeaderId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.filter.orderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.filter.type',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.filter.prdPpStatusCode',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.prdPpOperationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.prdPpHeaderId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'prdPpStatusCode',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.prdPpStatusCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpStatusUpdateLog.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpStatusUpdateLog, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
